export default "__VITE_ASSET__kjYMTBeW__"